import { useEffect, useRef, useState } from "react";
import { motion, useAnimation } from "framer-motion";
import { cn } from "@/lib/utils";
import { RiCloseFill } from "react-icons/ri";
import { FaAsterisk } from "react-icons/fa";
interface IEden {
  icon?: string;
  currentStep?: number;
  iconSize?: number;
  className?: string;
}

const Eden = (props: IEden) => {
  const { className, icon, iconSize } = props;
  const controls = useAnimation();
  const containerRef = useRef(null);
  const [isAnimating, setIsAnimating] = useState(true);
  useEffect(() => {
    controls.start("open");
  }, [icon]);
  const animatedLines = [
    {
      open: {
        height: ["20%", "40%", "20%", "40%", "20%", "40%", "20%"],
      },
    },
    {
      open: {
        height: ["40%", "20%", "40%", "20%", "40%", "20%", "40%"],
      },
    },
    {
      open: {
        height: ["20%", "40%", "20%", "40%", "20%", "40%", "20%"],
      },
    },
    {
      open: {
        height: ["60%", "20%", "60%", "20%", "60%", "20%", "60%"],
      },
    },
    {
      open: {
        height: ["20%", "40%", "20%", "40%", "20%", "40%", "20%"],
      },
    },
  ];

  const animationSettings = {
    duration: 1.5,
    yoyo: Infinity, // Use yoyo to create the "reverse" effect
  };

  useEffect(() => {
    if (isAnimating) {
      const intervalId = setInterval(() => {
        controls.start("open");
      }, 5000); // Trigger the animation every 5 seconds (5000 milliseconds)

      return () => {
        clearInterval(intervalId); // Clean up the interval when the component unmounts
      };
    }
  }, [isAnimating]);

  useEffect(() => {
    // Update animation when the container size changes
    controls.start("open");
  }, [containerRef.current]);

  const handleClick = () => {
    setIsAnimating(!isAnimating);
    controls.start("open");
  };

  return (
    <div
      ref={containerRef}
      className={cn(
        `flex px-2 gap-1 sm:gap-2 rounded-bl-[14.5px] items-center transition-all justify-center w-full h-full bg-[#FF9B23] rounded-t-[14.5px] `,
        className
      )}
      onClick={handleClick}
    >
      {!icon &&
        animatedLines.map((line, index) => {
          return (
            <motion.div
              key={index}
              className="w-full  bg-[#051F20] rounded-full"
              variants={line}
              initial={false}
              animate={controls}
              transition={animationSettings}
            ></motion.div>
          );
        })}
      {icon === "star" && (
        <FaAsterisk className="text-main-dark-green" size={iconSize || 24} />
      )}
      {icon === "close" && (
        <RiCloseFill className="text-main-dark-green" size={iconSize || 24} />
      )}
    </div>
  );
};

export default Eden;
